<template>
  <div class="new">
    <b-form @submit="onSubmit" @reset="onCancel">
      <b-container fluid >
        <b-row align-h="center">
          <b-col cols="10">
            <b-form-group
              id="input-group-1"
              class="label"
              label="Log*"
              label-for="log"
              description="Please input log. Don't input a personal information or confidential information.(**up to 2000 chars)"
            >
              <b-form-textarea
                id="log-textarea"
                placeholder="Enter log data..."
                rows="3"
                max-rows="8"
                required
                v-model="localLog"
                :state="checkLogLength"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col cols="10">
            <b-form-group
              id="input-group-2"
              class="label"
              label="Target*"
              label-for="target"
              description="Please input target OS or MW or SW name.(e.g. apache, mysql, centos, window etc.) (**up to 50 chars)"
            >
              <b-form-input
                id="target-text"
                v-model="localTarget"
                required
                placeholder="Enter target OS or MW or SW..."
                :state="checkTargetLength"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col cols="10">
            <b-form-group
              id="input-group-3"
              class="label"
              label="Version*"
              label-for="version"
              description="Please input target version. (e.g. 2.4, 5.6 etc.) (**up to 50 chars)"
            >
              <b-form-input
                id="version-text"
                v-model="localVersion"
                required
                placeholder="Enter version..."
                :state="checkVersionLength"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col cols="10">
            <b-form-group
              id="input-group-4"
              class="label"
              label="Cause of this log*"
              label-for="cause"
              description="Please input the cause of this log. support markdown (e.g. Because process have no permission to a file..) (**up to 2000 chars)"
            >
              <b-form-textarea
                id="cause-textarea"
                placeholder="Enter the cause of this log..."
                rows="3"
                max-rows="8"
                required
                v-model="localCause"
                :state="checkCauseLength"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col cols="10">
            <b-form-group
              id="input-group-5"
              class="label"
              label="Next Action for this log*"
              label-for="action"
              description="Please input the action for this log. support markdown (e.g. Set write permission to config file.) (**up to 2000 chars)"
            >
              <b-form-textarea
                id="action-textarea"
                placeholder="Enter the action for this log..."
                rows="3"
                max-rows="8"
                required
                v-model="localAction"
                :state="checkActionLength"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="start">
          <b-col cols="1"></b-col>
          <b-col cols="1">
            <b-form-group
              id="input-group-6"
              class="label"
              label="Public or Private"
              label-for="public"
            >
              <b-form-checkbox id="public-checkbox" align-h="start" v-model="localPublic" name="check-button" switch>
                <font-awesome-icon :icon="['fas', 'unlock']" />Public?
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <b-col align-self="end" cols="4">
            <b-button class="new-btn" @click="onCancel" variant="danger">Cancel</b-button>
            <b-button :disabled="validateError" class="new-btn" @click="onSubmit" variant="primary">Submit</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
  </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'
const apiUrl = 'https://logcrow.appspot.com/'
// const apiUrl = 'http://192.168.212.101:9999/'
// const apiUrl = 'http://localhost:9999/'
export default {
  name: 'Edit',
  props: ['objectID', 'log', 'target', 'version', 'cause', 'action', 'uid', 'created_at', 'public'],
  data() {
    return {
      origLog: {
        objectID: this.objectID,
        log: this.log,
        target: this.target,
        version: this.version,
        cause: this.cause,
        action: this.action,
        uid: this.uid,
        created_at: this.created_at,
        public: this.public
      }
    }
  },
  methods: {
    makeToast(variant = null, message) {
      this.$root.$bvToast.toast(message, {
        title: `${variant || 'message'}`,
        variant: variant,
        solid: true
      })
    },
    onSubmit() {
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        // ログイン状態でのみ登録実行
        let formData = {
          objectID: this.localObjectID,
          log: this.localLog,
          target: this.localTarget,
          version: this.localVersion,
          cause: this.localCause,
          action: this.localAction,
          uid: this.localUid,
          created_at: this.localCreated_at,
          public: this.localPublic
        }
        currentUser.getIdToken(true).then(async (idToken) => {
          let res = await axios.put(apiUrl + 'log', formData, {
            headers: {
              'Authorization': `Bearer ${idToken}`,
              'Content-Type': 'application/json'
            }
          })
          if (res.status == 200) {
            this.makeToast('success', 'Updated log information.')
            this.$bvModal.hide('edit-'+this.localObjectID)
          } else {
            this.makeToast('danger', 'Failed to update.')
            this.$bvModal.hide('edit-'+this.localObjectID)
          }
        }).catch(() => {
          this.makeToast('danger', 'Failed to update.')
          this.$bvModal.hide('edit-'+this.localObjectID)
        })
      } else {
        // 未ログイン状態なエラー
        this.makeToast('danger', 'Not logged in.')
        this.$router.push('/signin')
      }
    },
    onCancel() {
      this.localLog = this.origLog.log
      this.localObjectID = this.origLog.objectID
      this.localTarget = this.origLog.target
      this.localVersion = this.origLog.version
      this.localCause = this.origLog.cause
      this.localAction = this.origLog.action
      this.localUid = this.origLog.uid
      this.localCreated_at = this.origLog.created_at
      this.localPublic = this.origLog.public
      this.$bvModal.hide('edit-'+this.localObjectID)
    },
  },
  computed: {
    localLog: {
      get() {
        return this.log
      },
      set(newValue) {
        if (this.log !== newValue) this.$emit('update:log', newValue) 
      }
    },
    localObjectID: {
      get() {
        return this.objectID
      },
      set(newValue) {
        if (this.objectID !== newValue) this.$emit('update:objectID', newValue) 
      }
    },
    localVersion: {
      get() {
        return this.version
      },
      set(newValue) {
        if (this.version !== newValue) this.$emit('update:version', newValue) 
      }
    },
    localTarget: {
      get() {
        return this.target
      },
      set(newValue) {
        if (this.target !== newValue) this.$emit('update:target', newValue) 
      }
    },
    localAction: {
      get() {
        return this.action
      },
      set(newValue) {
        if (this.action !== newValue) this.$emit('update:action', newValue) 
      }
    },
    localCause: {
      get() {
        return this.cause
      },
      set(newValue) {
        if (this.cause !== newValue) this.$emit('update:cause', newValue) 
      }
    },
    localCreated_at: {
      get() {
        return this.created_at
      },
      set(newValue) {
        if (this.created_at !== newValue) this.$emit('update:created_at', newValue) 
      }
    },
    localPublic: {
      get() {
        return this.public
      },
      set(newValue) {
        if (this.public !== newValue) this.$emit('update:public', newValue) 
      }
    },
    localUid: {
      get() {
        return this.uid
      },
      set(newValue) {
        if (this.uid !== newValue) this.$emit('update:uid', newValue) 
      }
    },
    validateError() {
      if( this.localLog.length == 0 ||
          this.localLog.length > 2000 ||
          this.localTarget.length == 0 ||
          this.localTarget.length > 50 ||
          this.localCause.length == 0 ||
          this.localCause.length > 2000 ||
          this.localAction.length == 0 ||
          this.localAction.length > 2000 ||
          this.localVersion.length == 0 ||
          this.localVersion.length > 50
       ) {
         return true
      }
      return false
    },
    checkLogLength() {
      if( this.localLog.length > 2000 ) {
        return false
      }
      return null
    },
    checkTargetLength() {
      if( this.localTarget.length > 50 ) {
        return false
      }
      return null
    },
    checkVersionLength() {
      if( this.localVersion.length > 50 ) {
        return false
      }
      return null
    },
    checkCauseLength() {
      if( this.localCause.length > 2000 ) {
        return false
      }
      return null
    },
    checkActionLength() {
      if( this.localAction.length > 2000 ) {
        return false
      }
      return null
    },
  }
}
</script>

<style>
.new {
    margin: 16px
}
.label {
    text-align: left
}
.new-btn {
    margin: 10px;
}
.normal {
    font-size: 1.3em
}
.warning {
    font-size: 2em;
    color: #ef6c00
}
.limit {
    font-size: 2em;
    color: #ff4081
}
</style>
